import { Separator } from './Separator';

export { Separator };
